import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowDown01Icon, ArrowUp01Icon } from '@hugeicons/core-solid-rounded'
import { useLingui } from '@lingui/react/macro'

export default function UpDownButtons({
  onUp,
  onDown
}: {
  onUp: () => void
  onDown: () => void
}) {
  const { t } = useLingui()

  return (
    <div className="flex flex-col">
      <button
        className="size-5 text-text"
        aria-label={t({
          comment:
            'Button label to describe to the user that they can move a category up',
          message: `Move up`
        })}
        tabIndex={0}
        onClick={onUp}
      >
        <HugeiconsIcon icon={ArrowUp01Icon} className="size-full" />
      </button>
      <button
        className="size-5 text-text"
        aria-label={t({
          comment:
            'Button label to describe to the user that they can move a category down',
          message: `Move down`
        })}
        tabIndex={0}
        onClick={onDown}
      >
        <HugeiconsIcon icon={ArrowDown01Icon} className="size-full" />
      </button>
    </div>
  )
}
